"use client";

import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "../banner.module.css";
import { cn } from "@/src/utils/shadcn";
import { getStaggeredDelay } from "@/src/utils/set-staggered-delay";
import {
  AwardCardModel,
  AwardCardModelProps,
} from "../../cards/banner-images/award";
import Image from "next/image";

const iconStyle = cn(
  `w-[100px] h-[100px] rounded-full bg-transparent duration-350 text-white`
);
const cursorStyle = cn(`cursor-pointer`);

export interface AwardDialogProps {
  cards: AwardCardModelProps[];
}

export const AwardDialog = ({ cards }: AwardDialogProps) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setShowModal(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const Modal = () => {
    return (
      <div
        data-testid="backdrop"
        className={styles["modal-video"]}
        role="dialog"
        onClick={() => setShowModal(false)}
      >
        <div className={styles["modal-video-body"]}>
          <div className={styles["modal-video-inner"]}>
            <div className={styles["modal-video-wrap"]}>
              <button
                className={styles["modal-video-close-btn"]}
                onClick={() => setShowModal(false)}
              />
              {cards && cards.length > 0 && (
                <div className="-mx-1 flex flex-wrap justify-center gap-y-30px py-7">
                  {cards.map((cards, index) => (
                    <div
                      key={index}
                      data-aos-delay={getStaggeredDelay([200, 400, 600], index)}
                      className="w-full px-4 md:w-1/2 md:px-[15px] lg:w-1/3"
                    >
                      <AwardCardModel {...cards} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div data-testid="video-player">
      <span
        className={cn(cursorStyle, "z-10")}
        onClick={() => setShowModal(true)}
      >
        <span className={cn(iconStyle, "text-[2.5rem] md:text-[6.25rem]")}>
          <span>
            <Image
              width={105}
              height={105}
              src="/assets/images/premier-standards/AWARDS.webp"
              alt="Awards"
            />
          </span>
        </span>
      </span>

      {showModal && createPortal(<Modal />, document.body)}
    </div>
  );
};